// Copyright (c) StrangeBee 2023

import React, { ReactElement, ReactNode } from 'react';
import { Form, FormItemProps } from 'antd';
import { classList } from '@Helpers/className';

import './Item.scss';

export interface ItemProps<T> extends FormItemProps<T> {
    horizontal?: boolean;
    extraAction?: ReactNode;
}

export const Item = <T,>({
    className,
    horizontal = false,
    extraAction,
    label,
    children,
    ...props
}: ItemProps<T>): ReactElement => (
    <Form.Item<T>
        className={classList('th-form__item', className, { horizontal, 'extra-action': extraAction })}
        {...props}
        label={
            extraAction ? (
                <div className="th-form__item-label">
                    <span className="th-form__item-label__title required-place-mark">{label}</span>
                    <span className="th-form__item-label__actions">{extraAction}</span>
                </div>
            ) : (
                label
            )
        }
    >
        {children}
    </Form.Item>
);
